import { render } from "./notification_setting.vue?vue&type=template&id=7c621022&scoped=true&ts=true"
import script from "./notification_setting.vue?vue&type=script&lang=ts"
export * from "./notification_setting.vue?vue&type=script&lang=ts"

import "./notification_setting.vue?vue&type=style&index=0&id=7c621022&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c621022"]])

export default __exports__